import React, { useEffect, useState } from "react";
// import { FaSun } from "react-icons/fa";
// import { BsFillMoonFill } from "react-icons/bs";
import emoji from "react-easy-emoji";
import { useTheme } from "next-themes";

import "./ToggleButton.scss";

const ToggleButton = () => {
  const { theme, setTheme } = useTheme();
  const [dark, setDark] = useState(true);

  useEffect(() => {
    setTheme("dark");
  }, []);


  return (
    // Toogle 1
    // <div className="flex flex-initial flex-row justify-end">
    //   <div className="flex items-center mr-2">
    //     <input
    //       type="checkbox"
    //       className="checkbox"
    //       id="checkbox"
    //       onChange={() => setTheme(theme === "light" ? "dark" : "light")}
    //     />
    //     <label
    //       htmlFor="checkbox"
    //       className="flex items-center justify-between w-8 h-4 bg-darktheme rounded-2xl p-1 relative label cursor-pointer"
    //     >
    //       <FaSun className="fa-sun" />
    //       <BsFillMoonFill className="fa-moon" />
    //       <div className="w-3 h-3 absolute bg-white rounded-full ball" />
    //     </label>
    //   </div>
    // </div>

    // 2nd
    <label className="switch">
      <input
        type="checkbox"
        checked={dark}
        onChange={() => {
          setTheme(theme === "light" ? "dark" : "light");
          setDark((prev) => !prev);
        }}
      />
      <span className="slider round">
        <span className="emoji pl-[1px]">
          {dark ? emoji("🌜") : emoji("☀️")}
        </span>
      </span>
    </label>

    //  second toggle
    // <span
    //   onClick={() => setTheme(theme === "light" ? "dark" : "light")}
    //   className="toggle w-14 h-14 md:w-10 md:h-10 dark:bg-gray-700 bg-amber-400 flex rounded-full shadow-lg cursor-pointer text-white items-center justify-center "
    // >
    //   {theme === "light" ? (
    //     <svg
    //       className="w-6 h-6"
    //       fill="none"
    //       stroke="yellow"
    //       viewBox="0 0 24 24"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         strokeWidth="2"
    //         d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
    //       ></path>
    //     </svg>
    //   ) : (
    //     <svg
    //       className="w-6 h-6"
    //       fill="#fff"
    //       stroke="currentColor"
    //       viewBox="0 0 24 24"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         strokeWidth="2"
    //         d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
    //       ></path>
    //     </svg>
    //   )}
    // </span>
    // );
  );
};

export default ToggleButton;
